import axios from 'axios';
import { BASE_HOST_URL } from '../config';

let baseURL = BASE_HOST_URL;

if (process.env.NODE_ENV === 'development') {
  baseURL = 'http://localhost:3005';
}

export function invoices(startDate, endDate) {
  return axios.get(`${baseURL}/api/v1/invoices?startDate=${startDate}&endDate=${endDate}`);
}

export function downloadSummary(startDate, endDate) {
  return axios.get(`${baseURL}/api/v1/invoices/summary?startDate=${startDate}&endDate=${endDate}`, { responseType: 'blob' });
}



// WEBPACK FOOTER //
// ./src/services/invoices.js